import googleIcon from '../../assets/googleIcon.svg';
import './GoogleLoginButton.css';
import { isWebView } from '../../utils/detectWebContainer';
import { useBrandContext } from '../../context/BrandContext';

const GoogleLoginButton = () => {
  const brandContext = useBrandContext();

  const brand = brandContext?.brandName ?? 'spott';
  const webView = isWebView();

  // URI CADASTRADO no console do Google
  const redirectUri = `${window.location.origin}/redir`;

  const login = () => {
    const state = encodeURIComponent(
      JSON.stringify({
        loginBrand: brand,
        webView,
        flowName: 'GeneralOAuthFlow',
        postLoginPath: `/${brand}/app`,
      })
    );

    const googleUrl =
      'https://accounts.google.com/o/oauth2/v2/auth' +
      `?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      '&response_type=token' +
      '&scope=openid%20email%20profile' +
      '&prompt=consent' +
      `&state=${state}`;

    window.location.href = googleUrl;
  };

  return (
    <button
      type='button'
      className='google-login-button'
      onClick={() => login()}
    >
      <img alt='google-icon' src={googleIcon} />
      Continuar com Google
    </button>
  );
};

export default GoogleLoginButton;
